import { render, staticRenderFns } from "./AddOrgPruductPay2.vue?vue&type=template&id=0e05ed29&scoped=true"
import script from "./AddOrgPruductPay2.vue?vue&type=script&lang=js"
export * from "./AddOrgPruductPay2.vue?vue&type=script&lang=js"
import style0 from "./AddOrgPruductPay2.vue?vue&type=style&index=0&id=0e05ed29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e05ed29",
  null
  
)

export default component.exports